var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 0C3.14021 0 0 3.14013 0 6.99996C0 10.8598 3.14021 14 6.99996 14C10.8597 14 13.9999 10.8598 13.9999 6.99996C13.9999 3.14013 10.8598 0 6.99996 0ZM11.0195 5.81761L6.62174 10.2153C6.43475 10.4023 6.18619 10.5052 5.92177 10.5052C5.65735 10.5052 5.40879 10.4023 5.2218 10.2153L2.98046 7.974C2.79347 7.787 2.69048 7.53844 2.69048 7.27402C2.69048 7.00953 2.79347 6.76097 2.98046 6.57397C3.16738 6.38698 3.41595 6.28399 3.68044 6.28399C3.94485 6.28399 4.19349 6.38698 4.38041 6.57405L5.9217 8.11526L9.61937 4.41759C9.80636 4.2306 10.0549 4.12768 10.3193 4.12768C10.5838 4.12768 10.8323 4.2306 11.0193 4.41759C11.4054 4.8037 11.4054 5.43165 11.0195 5.81761Z",
    fill: "#14A53C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.06b77b74e45c7e433d62db26c5061677.svg";
export { ForwardRef as ReactComponent };